import detectIndent from './detectIndent';
var DEFAULT_INDENTATION = '  ';

function getIndent(text) {
  var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_INDENTATION;
  return detectIndent(text).indent || defaultValue;
}

export default getIndent;